/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import AvatarGroup from '@atlaskit/avatar-group';
import { mq } from '../../common/utils';
export const CollaboratorList = ({
  items,
  handleAvatarClick = () => {},
  handleMoreAvatarsClick = () => {},
  testId = 'collaborator-list'
}) => {
  if (items.length === 0) {
    return null;
  }
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("span", {
      css: mq({
        display: ['none', 'inherit']
      })
    }, jsx(AvatarGroup, {
      maxCount: 4,
      appearance: "stack",
      size: "small",
      data: items,
      onAvatarClick: event => {
        event.stopPropagation();
        event.preventDefault();
        handleAvatarClick(event);
      },
      onMoreClick: event => {
        event.stopPropagation();
        event.preventDefault();
        handleMoreAvatarsClick(event);
      },
      testId: testId
    }))
  );
};